import { useQuery } from '@tanstack/react-query';

import URLS from 'constants/urls';
import { reportError } from 'helpers/error-logging';
import { httpClient } from 'helpers/http';

export const skuItemReportsKeys = {
  all: ['skuItemReports'],
  items: filter => [...skuItemReportsKeys.all, 'items', filter],
};

// Response parsing moves to the generated protobuf types once SKU-877 publishes
// the sku_item_reports contract; until then the endpoint is never enabled.
async function fetchItemsReport(filter) {
  try {
    const response = await httpClient.post(URLS.reports.skuItems, { filter });
    return response?.data || {};
  } catch (error) {
    reportError(error);
    throw error;
  }
}

export function useItemsReportQuery(filter) {
  return useQuery({
    queryKey: skuItemReportsKeys.items(filter),
    queryFn: () => fetchItemsReport(filter),
    enabled: false,
  });
}
